import { render, staticRenderFns } from "./modal-documento.vue?vue&type=template&id=de029610&"
import script from "./modal-documento.component.ts?vue&type=script&lang=ts&"
export * from "./modal-documento.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports